var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import _ from 'underscore';

var CommonCoveragesCtrl = function () {
    _createClass(CommonCoveragesCtrl, null, [{
        key: '$inject',
        get: function get() {
            return ['StateUtils', 'CoveragesUtil', 'ModalService', '$filter'];
        }
    }]);

    function CommonCoveragesCtrl(StateUtils, CoveragesUtil, ModalService, $filter) {
        _classCallCheck(this, CommonCoveragesCtrl);

        this.StateUtils = StateUtils;
        this.CoveragesUtil = CoveragesUtil;
        this.ModalService = ModalService;
        this.$filter = $filter;
    }

    _createClass(CommonCoveragesCtrl, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            this.model = this.StateUtils.activeDataForState(true).model;
            this.coverages = this.model.lobData.commercialPackage.generalLiability.coverables.coverages;
            this.coverages.value = this.coverages.value || [];
            var cpCoverages = this.model.lobData.commercialPackage.commercialProperty.coverables.value.locations[0].buildings[0].coverages;
            if (cpCoverages) {
                cpCoverages.forEach(function (cov) {
                    _this.coverages.value.push(cov);
                });
            }
            var imCoverages = this.model.lobData.commercialPackage.inlandMarine.coverables.coverages;
            this.coverages.value.push(imCoverages.value[0]);

            this.coverageFilter = '';
            this.prevResult = '';

            this.nextStep = this.nextStep.bind(this);
            this.onCovChange = this.onCovChange.bind(this);
        }
    }, {
        key: 'showError',
        value: function showError() {
            this.ModalService.showError('ama.edge.quoteandbind.cpp.components.coverages.common.commonCoveragesCtrl.Error', 'ama.edge.quoteandbind.cpp.components.coverages.common.commonCoveragesCtrl.An error has occurred...');
        }
    }, {
        key: 'onCovChange',
        value: function onCovChange(coverage) {
            var _this2 = this;

            var lobCoverages = _.mapObject(this.model.lobData, function (lob) {
                return lob.coverages ? lob.coverages.value : undefined;
            });

            var jobID = this.model.quoteID ? this.model.quoteID.value : this.model.jobID.value;
            var sessionUUID = this.model.sessionUUID ? this.model.sessionUUID.value : undefined;
            var sequencer = this.CoveragesUtil.getSequencer();
            var operation = sequencer(this.updateCoverages(jobID, lobCoverages, sessionUUID));
            this.coveragesLoading = true;

            return operation.then(function (result) {
                var coverages = result.commercialPackage ? result.commercialPackage : result.lobData.commercialPackage.generalLiability.coverables.coverages;
                _this2.setCoverages(coverage, coverages); // This function should be override by a additional/general coverages subclass
            }).catch(this.showError).finally(function () {
                _this2.coveragesLoading = false;
            });
        }
    }, {
        key: 'nextStep',
        value: function nextStep(callback, form) {
            var _this3 = this;

            if (this.CoveragesUtil.validateForm(form)) {
                this.onCovChange().then(function () {
                    return callback(_this3.model);
                }, function () {
                    callback();
                }).catch(this.showError);
            } else {
                callback();
            }
        }
    }, {
        key: 'filteredCoverages',
        value: function filteredCoverages() {
            var result = this.$filter('filter')(this.coverages.value.additionalCoverages, {
                name: this.coverageFilter
            });
            if (_.isEqual(this.prevResult, result)) {
                return this.prevResult;
            }

            this.prevResult = result;
            return result;
        }
    }]);

    return CommonCoveragesCtrl;
}();

export default CommonCoveragesCtrl;


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/coverages/common/coveragesCtrl.js
// module id = 295
// module chunks = 0